<ng-template #recordsReportTemplateRef>
  @if (page$ | async; as page) {
    <div class="p-paginator-current">
      @if (page.filteredCount > 0) {
        <span class="pr-3"
              i18n>Filtered: {{page.filteredCount}}</span>
      }
    </div>
  }
</ng-template>